'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.get = get;
exports.post = post;
exports.put = put;
exports.del = del;
exports.upload = upload;
exports.execute = execute;

var _daoConfiguration = require('./configuration/daoConfiguration');

function get(url) {
    return execute(url, 'GET');
}

function post(url, data) {
    return execute(url, 'POST', data);
}

function put(url, data) {
    return execute(url, 'PUT', data);
}

function del(url) {
    return execute(url, 'DELETE');
}

function upload(url, data, onProgress, authToken) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', (0, _daoConfiguration.getDaoBaseUrl)() + url);
        xhr.setRequestHeader('AUTH-TOKEN', authToken);
        xhr.setRequestHeader('Device-Id', (0, _daoConfiguration.getDaoDeviceId)());
        xhr.setRequestHeader('Device-Type', (0, _daoConfiguration.getDaoDeviceType)());
        xhr.onload = function () {
            if (xhr.status === 401 || xhr.status === 503) {
                return reject({
                    status: xhr.status,
                    payload: {}
                });
            } else if (xhr.status >= 200 && xhr.status < 300) {
                return resolve(JSON.parse(xhr.responseText));
            } else {
                reject({
                    status: xhr.status,
                    payload: xhr.statusText
                });
            }
        };
        if (xhr.upload) {
            xhr.upload.onprogress = function (event) {
                if (event.lengthComputable) {
                    var percentComplete = event.loaded / event.total * 100;
                    onProgress(percentComplete);
                }
            };
        }
        xhr.send(data);
    });
}

function execute(url, method, data, onProgress, authToken) {
    var startTime = new Date();
    if (method === 'UPLOAD') {
        return upload(url, data, onProgress, authToken);
    } else {
        var config = {
            method: method,
            headers: getHeaders(authToken)
        };
        if (typeof data !== 'undefined') {
            config.body = JSON.stringify(data);
        }
        return timeout(20000, fetch((0, _daoConfiguration.getDaoBaseUrl)() + url, config).then(function (response) {
            sendTimingData(method, url, startTime);
            return response;
        }).then(handleResponse));
    }
}

function getHeaders(authToken) {
    return {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AUTH-TOKEN': authToken,
        'Device-Id': (0, _daoConfiguration.getDaoDeviceId)(),
        'Device-Type': (0, _daoConfiguration.getDaoDeviceType)()
    };
}

function timeout(ms, promise) {
    return new Promise(function (resolve, reject) {
        setTimeout(function () {
            reject({
                status: -2,
                payload: {
                    errors: {
                        globalErrors: 'common.errors.somethingWrong'
                    }
                }
            });
        }, ms);
        promise.then(resolve, reject);
    });
}

function handleResponse(response) {
    if (response.status === 401 || response.status === 503) {
        return Promise.reject({
            status: response.status,
            payload: {}
        });
    } else {
        return response.json().then(function (json) {
            return response.ok ? json : Promise.reject({
                status: response.status,
                payload: json
            });
        }).catch(function (err) {
            return response.ok && err.name !== 'SyntaxError' ? {} : Promise.reject({
                status: response.status,
                payload: {}
            });
        });
    }
}

function sendTimingData(method, url, startTime) {
    var finishTime = new Date();
    (0, _daoConfiguration.getDaoAnalytics)().sendTiming('Dao', method, finishTime.getTime() - startTime.getTime(), url);
}

function sendException(xhr) {
    (0, _daoConfiguration.getDaoAnalytics)().sendException(xhr.statusText, false);
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-fetch/dist/Dao.js
 ** module id = 643
 ** module chunks = 0
 **/